import styles from './Timeline.module.scss';

import clsx from 'clsx';
import {useMemo} from 'react';
import {useTimelineContext} from '../../contexts';
import {usePreviewSettings} from '../../hooks';

function formatTime(frame: number, fps: number): string {
  const totalSeconds = Math.floor(frame / fps);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export function Timestamps() {
  const {
    framesToPercents,
    firstVisibleFrame,
    lastVisibleFrame,
    segmentDensity,
  } = useTimelineContext();
  const {fps} = usePreviewSettings();

  const timestamps = useMemo(() => {
    const timestamps = [];
    const clamped = Math.max(1, segmentDensity);
    for (let i = firstVisibleFrame; i < lastVisibleFrame; i += clamped) {
      timestamps.push(
        <div
          className={clsx(styles.timestamp, {
            [styles.odd]: segmentDensity > 0 && (i / segmentDensity) % 2 !== 0,
          })}
          style={{left: `${framesToPercents(i)}%`}}
          key={i}
          data-frame={formatTime(i, fps)}
        />,
      );
    }
    return timestamps;
  }, [firstVisibleFrame, lastVisibleFrame, framesToPercents, segmentDensity, fps]);

  return <>{timestamps}</>;
}
